import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable, of } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { GlobalVariable } from "app/global/global";

export interface UmbralSondaje {
  desde: number;
  color: string;
}

export interface PeriodontogramaConfig {
  umbralesSondaje: UmbralSondaje[];
  colores: { sangrado: string; supuracion: string; placa: string };
}

const DEFAULTS: PeriodontogramaConfig = {
  umbralesSondaje: [
    { desde: 4, color: "#fbc02d" },
    { desde: 6, color: "#e53935" },
  ],
  colores: { sangrado: "#e53935", supuracion: "#ff9800", placa: "#1976d2" },
};

@Injectable({ providedIn: "root" })
export class PeriodontogramaConfigService {
  private url = GlobalVariable.BASE_API_URL + "api/periodontograma-config";

  private _config = new BehaviorSubject<PeriodontogramaConfig>(DEFAULTS);
  config$ = this._config.asObservable();

  constructor(private http: HttpClient) {}

  get config(): PeriodontogramaConfig {
    return this._config.value;
  }

  cargar(): Observable<PeriodontogramaConfig | null> {
    return this.http.get<PeriodontogramaConfig>(this.url).pipe(
      tap((cfg) => {
        if (cfg?.umbralesSondaje) this._config.next(cfg);
      }),
      catchError(() => of(null)),
    );
  }

  guardar(payload: PeriodontogramaConfig): Observable<any> {
    return this.http.put(this.url, payload).pipe(tap(() => this.cargar().subscribe()));
  }

  colorSondaje(valor: number | null): string | null {
    if (valor === null) return null;
    let color: string | null = null;
    for (const u of this.config.umbralesSondaje) {
      if (valor >= u.desde) color = u.color;
    }
    return color;
  }
}
